import { CSSProperties } from 'react';
import { FieldErrorsImpl, FieldValues, Path, UnPackAsyncDefaultValues, UseFormRegister } from 'react-hook-form';

interface TextInputProps<T extends FieldValues> {
  name: Path<UnPackAsyncDefaultValues<T>>;
  register: UseFormRegister<T>;
  errors?: Partial<
    FieldErrorsImpl<{
      [x: string]: unknown;
    }>
  > | undefined;
  textInputClassName?: string | undefined;
  textInputStyle?: CSSProperties | undefined;
}

export function TextInput<T extends FieldValues>({
  name,
  register,
  errors,
  textInputClassName,
  textInputStyle,
}: TextInputProps<T>) {
  return (
    <>
      <input
        type="text"
        className={textInputClassName}
        style={textInputStyle}
        {...register(name)}
      />
      {
        (errors)
        &&
        (errors[name]?.message)
        &&
        (
          <>
            <br />
            <span className="form-error">
              {errors[name]?.message}
            </span>
            <br />
          </>
        )
      }
    </>
  );
}

TextInput.defaultProps = {
  errors: undefined,
  textInputClassName: undefined,
  textInputStyle: undefined,
};